import { createAction, createErrorAction } from '../../../helpers';
import { ErrorResponse, FleetReportData } from '../../../../@types';
import { ReportsTypes } from '../../../../@types/enums/redux/store/ReportsTypes';

export const reportsRequest = () => createAction(ReportsTypes.REPORTS_REQUEST);

export const reportsSuccess = (payload: FleetReportData[]) =>
  createAction(ReportsTypes.REPORTS_SUCCESS, payload);

export const reportsFailure = <E extends ErrorResponse>(error: E) =>
  createErrorAction(ReportsTypes.REPORTS_FAILURE, error);

export const setDisplayReports = (payload: FleetReportData[]) =>
  createAction(ReportsTypes.SET_DISPLAY_REPORTS, payload);

export const selectReport = (payload: FleetReportData | null) =>
  createAction(ReportsTypes.SELECT_REPORT, payload);

export const reportRequest = () => createAction(ReportsTypes.REPORT_REQUEST);

export const reportSuccess = (payload: FleetReportData) =>
  createAction(ReportsTypes.REPORT_SUCCESS, payload);

export const reportFailure = <E extends ErrorResponse>(error: E) =>
  createErrorAction(ReportsTypes.REPORT_FAILURE, error);

export const regenerateReportRequest = () =>
  createAction(ReportsTypes.REGENERATE_REPORT_REQUEST);

export const regenerateReportSuccess = (payload: FleetReportData) =>
  createAction(ReportsTypes.REGENERATE_REPORT_SUCCESS, payload);

export const regenerateReportFailure = <E extends ErrorResponse>(error: E) =>
  createErrorAction(ReportsTypes.REGENERATE_REPORT_FAILURE, error);
